import { render, staticRenderFns } from "./Exclusions.vue?vue&type=template&id=7c8d1f2d&scoped=true"
import script from "./Exclusions.vue?vue&type=script&lang=ts"
export * from "./Exclusions.vue?vue&type=script&lang=ts"
import style0 from "./Exclusions.vue?vue&type=style&index=0&id=7c8d1f2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8d1f2d",
  null
  
)

export default component.exports